import React from 'react';
import { Route } from 'react-router-dom';
import slug from 'constants/slug';
import EnvironmentProtectionWorkList from './environment-protection-work-List';
import EnvironmentProtectionWorkCreate from './environment-protection-work-Create';
import EnvironmentProtectionWorkEdit from './environment-protection-work-Edit';
import EnvironmentProtectionWorkView from './environment-protection-work-View';

export default props => [
  <Route
    exact
    key={slug.ENVIRONMENT_PROTECTION_WORK.LIST}
    path={slug.ENVIRONMENT_PROTECTION_WORK.LIST}
    render={matchProps => <EnvironmentProtectionWorkList {...matchProps} {...props} />}
  />,
  <Route
    key={slug.ENVIRONMENT_PROTECTION_WORK.CREATE}
    path={slug.ENVIRONMENT_PROTECTION_WORK.CREATE}
    render={matchProps => <EnvironmentProtectionWorkCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.ENVIRONMENT_PROTECTION_WORK.VIEW}
    path={slug.ENVIRONMENT_PROTECTION_WORK.VIEW}
    render={matchProps => <EnvironmentProtectionWorkView {...matchProps} {...props} />}
  />,
  <Route
    key={slug.ENVIRONMENT_PROTECTION_WORK.EDIT}
    path={slug.ENVIRONMENT_PROTECTION_WORK.EDIT}
    render={matchProps => <EnvironmentProtectionWorkEdit {...matchProps} {...props} />}
  />
];


// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/index.js